import { IconFunctionalHouse16 } from '@cian/ui-kit-design-tokens/icons';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import * as styles from './BuildingIcon.css';

interface IBuildingIconProps {
  isActive?: boolean;
  isViewed?: boolean;
}

export const BuildingIcon = ({ isActive, isViewed }: IBuildingIconProps): ReactNode => {
  return (
    <div className={clsx(styles['building-icon'], isActive && styles['active'], isViewed && styles['viewed'])}>
      <IconFunctionalHouse16 color={isActive ? 'icon-positive-default' : 'icon-inverted-default'} />
    </div>
  );
};

export const getBuildingIcon = (props: IBuildingIconProps) => renderToStaticMarkup(<BuildingIcon {...props} />);
